export class PriceHandler {
    constructor() {
        this.grossPriceRadios = document.querySelectorAll('.gross-price-btn1');
        this.grossPriceRadio = document.querySelector('.gross-price-btn1');
        this.netPriceRadios = document.querySelectorAll('.net-price-btn1');
        this.netPriceRadio = document.querySelector('.net-price-btn1');
        this.grossPriceElements = document.getElementsByClassName('gross-price');
        this.netPriceElements = document.getElementsByClassName('net-price');
    }

    handleRadioChange(radio) {
        if (radio.checked) {
            if (radio.classList.contains('gross-price-btn1')) {

                Array.from(this.grossPriceElements).forEach(function (element) {
                    element.classList.add('active');
                });
                Array.from(this.netPriceElements).forEach(function (element) {
                    element.classList.remove('active');
                });
            } else if (radio.classList.contains('net-price-btn1')) {
                Array.from(this.grossPriceElements).forEach(function (element) {
                    element.classList.remove('active');
                });
                Array.from(this.netPriceElements).forEach(function (element) {
                    element.classList.add('active');
                });
            }

        }
    }

    initialize() {

        let grossPriceRadios = document.querySelectorAll('.gross-price-btn1');
        grossPriceRadios.forEach((radio) => {

            radio.addEventListener('change', () => {
                this.handleRadioChange(radio)
            });
        });

        let netPriceRadios = document.querySelectorAll('.net-price-btn1');
        netPriceRadios.forEach((radio) => {

            radio.checked = true;
            radio.addEventListener('change', () => {
                this.handleRadioChange(radio)
            });
        });

        document.addEventListener('DOMContentLoaded', function () {

            const grossPriceButtons = document.querySelectorAll('input[type="radio"][value="net-price"]');

            grossPriceButtons.forEach(button => {
                button.checked = true;
            });
        });


    }


}